import React from "react";
import { useInView } from "react-intersection-observer";

// css
import * as styles from "./LogoCarousel.module.css";

// Import all company logos
import img1 from "../../../images/company-logos/img-1.png";
import img2 from "../../../images/company-logos/img-2.png";
import img3 from "../../../images/company-logos/img-3.png";
import img4 from "../../../images/company-logos/img-4.png";
import img5 from "../../../images/company-logos/img-5.png";
import img6 from "../../../images/company-logos/img-6.png";
import img7 from "../../../images/company-logos/img-7.png";
import img8 from "../../../images/company-logos/img-8.png";
import img9 from "../../../images/company-logos/img-9.png";
import img10 from "../../../images/company-logos/img-10.png";
import img49 from "../../../images/company-logos/image 49.png";
import img50 from "../../../images/company-logos/image 50.png";
import img51 from "../../../images/company-logos/image 51.png";
import img52 from "../../../images/company-logos/image 52.png";
import img53 from "../../../images/company-logos/image 53.png";
import img54 from "../../../images/company-logos/image 54.png";
import img56 from "../../../images/company-logos/image 56.png";
import img57 from "../../../images/company-logos/image 57.png";
import img58 from "../../../images/company-logos/image 58.png";
import img59 from "../../../images/company-logos/image 59.png";
import img61 from "../../../images/company-logos/image 61.png";
import img62 from "../../../images/company-logos/image 62.png";
import img65 from "../../../images/company-logos/image 65.png";
import img66 from "../../../images/company-logos/image 66.png";

const LogoCarouselComponent = ({
  title = "Trusted by leading organisations across India",
  backgroundColor = "#E7F3FE",
  logos = [],
  speed = 40, // Animation duration in seconds (lower = faster)
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Default company logos if none provided
  const defaultLogos = [
    { src: img1, alt: "Heritage" },
    { src: img2, alt: "RPL" },
    { src: img3, alt: "Uflex" },
    { src: img4, alt: "Truworth Wellness" },
    { src: img5, alt: "Plancover" },
    { src: img6, alt: "EPFO" },
    { src: img7, alt: "Company 7" },
    { src: img8, alt: "Company 8" },
    { src: img9, alt: "Company 9" },
    { src: img10, alt: "Company 10" },
    { src: img49, alt: "Company 11" },
    { src: img50, alt: "Company 12" },
    { src: img51, alt: "Company 13" },
    { src: img52, alt: "Company 14" },
    { src: img53, alt: "Company 15" },
    { src: img54, alt: "Company 16" },
    { src: img56, alt: "Company 18" },
    { src: img57, alt: "Company 19" },
    { src: img58, alt: "Company 20" },
    { src: img59, alt: "Company 21" },
    { src: img61, alt: "Company 22" },
    { src: img62, alt: "Company 23" },
    { src: img65, alt: "Company 25" },
    { src: img66, alt: "Company 26" },
  ];

  const displayLogos = logos.length > 0 ? logos : defaultLogos;

  // Determine if backgroundColor is a gradient or solid color
  const isGradient = backgroundColor.includes("gradient");
  const backgroundStyle = isGradient
    ? { backgroundImage: backgroundColor }
    : { backgroundColor };

  return (
    <section className={styles.logoCarouselWrapper} style={backgroundStyle}>
      <div
        className={`container-fluid scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        <div className="row">
          <div className="col-12">
            <h2 className={styles.title}>{title}</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className={styles.carouselContainer}>
              <div
                className={styles.carouselTrack}
                style={{ animationDuration: `${speed}s` }}
              >
                {/* First set of logos */}
                {displayLogos.map((logo, index) => (
                  <div key={`logo-1-${index}`} className={styles.logoItem}>
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className={styles.logoImage}
                      loading="lazy"
                    />
                  </div>
                ))}
                {/* Duplicate set for seamless loop */}
                {displayLogos.map((logo, index) => (
                  <div key={`logo-2-${index}`} className={styles.logoItem}>
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className={styles.logoImage}
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoCarouselComponent;
